import React from 'react';
import { inject } from 'mobx-react';
import { Button } from 'common/lazy';
import { Link } from 'react-router-dom';

import { Spacer } from 'public/components';
import { Layout, SVGIcon as Icon } from 'common/components';

function PayForParkingCongrats({ me }) {
  return (
    <>
      <Spacer size="xs" />
      <Layout>
        <div>
          <Icon name="check-circle" size="large" />
        </div>
        <Spacer size="xs" />
        <h4>You're all set!</h4>
        <Spacer size="xs" />
        <p>We’ll send a confirmation to {me.user.email}</p>
        <Spacer size="xs" />
        <p>
          You can view and manage your bookings on{' '}
          <Link to="/profile/orders">profile page</Link>
        </p>
        <Spacer size="s" />
        <Button as={Link} to="/" fluid>
          Continue browsing
        </Button>
      </Layout>
      <Spacer size="xs" />
    </>
  );
}

export default inject('me')(PayForParkingCongrats);
